// Theme: shape-theory
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'shape-theory',
  name: 'SHAPE THEORY',
  tagline: 'SHAPE THEORY',
  description: 'Teoria das formas. Bauhaus moderno com laranja geometrico sobre escuro.',
  category: 'system-core',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0F0E08', '#1F1D10', '#F28E2B', '#F4EAD6'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-shape-theory'
  },
  colorVars: {
    '--accent': '#F28E2B',
    '--accent-foreground': '#0F0E08',
    '--background': '#0F0E08',
    '--border': '#7A6A2A',
    '--card': '#1F1D10',
    '--card-border-active': 'rgba(242, 142, 43, 0.48)',
    '--card-completed': '#1B190E',
    '--card-foreground': '#F4EAD6',
    '--card-glow': 'rgba(242, 142, 43, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0E08',
    '--foreground': '#F4EAD6',
    '--hold-fill': '#F28E2B',
    '--input': '#7A6A2A',
    '--modal-bg': '#0F0E08',
    '--modal-border': '#7A6A2A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A6A2A',
    '--muted-foreground': '#F4EAD6',
    '--nav-active': '#F28E2B',
    '--nav-bg': '#1F1D10',
    '--popover': '#1F1D10',
    '--popover-foreground': '#F4EAD6',
    '--primary': '#F28E2B',
    '--primary-foreground': '#0F0E08',
    '--ring': '#F28E2B',
    '--secondary': '#7A6A2A',
    '--secondary-foreground': '#F4EAD6',
    '--streak': '#F28E2B',
    '--success': '#22c55e',
    '--success-foreground': '#0F0E08',
    '--xp': '#F28E2B',
    '--xp-bg': '#1F1D10'
  },
  resolvedVars: {
    '--accent': '#F28E2B',
    '--accent-foreground': '#0F0E08',
    '--accent-foreground-hsl': '51 30% 5%',
    '--accent-foreground-oklch': 'from #0F0E08 l c h',
    '--accent-hsl': '30 88% 56%',
    '--accent-oklch': 'from #F28E2B l c h',
    '--background': '#0F0E08',
    '--background-hsl': '51 30% 5%',
    '--background-oklch': 'from #0F0E08 l c h',
    '--border': '#7A6A2A',
    '--border-hsl': '48 49% 32%',
    '--border-oklch': 'from #7A6A2A l c h',
    '--border-w': '1px',
    '--card': '#1F1D10',
    '--card-border-active': 'rgba(242, 142, 43, 0.48)',
    '--card-completed': '#1B190E',
    '--card-completed-hsl': '51 32% 8%',
    '--card-completed-oklch': 'from #1B190E l c h',
    '--card-foreground': '#F4EAD6',
    '--card-foreground-hsl': '40 58% 90%',
    '--card-foreground-oklch': 'from #F4EAD6 l c h',
    '--card-glow': 'rgba(242, 142, 43, 0.10)',
    '--card-hsl': '52 32% 9%',
    '--card-oklch': 'from #1F1D10 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F0E08',
    '--destructive-foreground-hsl': '51 30% 5%',
    '--destructive-foreground-oklch': 'from #0F0E08 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F4EAD6',
    '--foreground-hsl': '40 58% 90%',
    '--foreground-oklch': 'from #F4EAD6 l c h',
    '--hold-fill': '#F28E2B',
    '--hold-fill-hsl': '30 88% 56%',
    '--hold-fill-oklch': 'from #F28E2B l c h',
    '--input': '#7A6A2A',
    '--input-hsl': '48 49% 32%',
    '--input-oklch': 'from #7A6A2A l c h',
    '--modal-bg': '#0F0E08',
    '--modal-bg-hsl': '51 30% 5%',
    '--modal-bg-oklch': 'from #0F0E08 l c h',
    '--modal-border': '#7A6A2A',
    '--modal-border-hsl': '48 49% 32%',
    '--modal-border-oklch': 'from #7A6A2A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A6A2A',
    '--muted-foreground': '#F4EAD6',
    '--muted-foreground-hsl': '40 58% 90%',
    '--muted-foreground-oklch': 'from #F4EAD6 l c h',
    '--muted-hsl': '48 49% 32%',
    '--muted-oklch': 'from #7A6A2A l c h',
    '--nav-active': '#F28E2B',
    '--nav-active-hsl': '30 88% 56%',
    '--nav-active-oklch': 'from #F28E2B l c h',
    '--nav-bg': '#1F1D10',
    '--nav-bg-hsl': '52 32% 9%',
    '--nav-bg-oklch': 'from #1F1D10 l c h',
    '--popover': '#1F1D10',
    '--popover-foreground': '#F4EAD6',
    '--popover-foreground-hsl': '40 58% 90%',
    '--popover-foreground-oklch': 'from #F4EAD6 l c h',
    '--popover-hsl': '52 32% 9%',
    '--popover-oklch': 'from #1F1D10 l c h',
    '--primary': '#F28E2B',
    '--primary-foreground': '#0F0E08',
    '--primary-foreground-hsl': '51 30% 5%',
    '--primary-foreground-oklch': 'from #0F0E08 l c h',
    '--primary-hsl': '30 88% 56%',
    '--primary-oklch': 'from #F28E2B l c h',
    '--radius': '12px',
    '--ring': '#F28E2B',
    '--ring-hsl': '30 88% 56%',
    '--ring-oklch': 'from #F28E2B l c h',
    '--secondary': '#7A6A2A',
    '--secondary-foreground': '#F4EAD6',
    '--secondary-foreground-hsl': '40 58% 90%',
    '--secondary-foreground-oklch': 'from #F4EAD6 l c h',
    '--secondary-hsl': '48 49% 32%',
    '--secondary-oklch': 'from #7A6A2A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F28E2B',
    '--streak-hsl': '30 88% 56%',
    '--streak-oklch': 'from #F28E2B l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F0E08',
    '--success-foreground-hsl': '51 30% 5%',
    '--success-foreground-oklch': 'from #0F0E08 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(30 88% 56% / 0.15)',
    '--xp': '#F28E2B',
    '--xp-bg': '#1F1D10',
    '--xp-bg-hsl': '52 32% 9%',
    '--xp-bg-oklch': 'from #1F1D10 l c h',
    '--xp-hsl': '30 88% 56%',
    '--xp-oklch': 'from #F28E2B l c h'
  }
}
